import { createAction } from "redux-actions";

// TODO: this should eventually be handled via mapState
export const setMapCenter = createAction("SET_MAP_CENTER");
export const setMapZoom = createAction("SET_MAP_ZOOM");
